import React from "react";
import "./NotFound.css";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  const Explore_btn_lnk = () => {
    window.open("https://d2jns.app.link/download-fabits", "_blank");
  };

  return (
    <div className="not-found-container">
      <img src="Error/error.svg" alt="Error Image" className="error-image" />
      <div className="error-text">
        <p>Oops! That page doesn't exist</p>
        <p className="small-text">Fret not, we've still got you covered!</p>
        <div className="button-container">
          <button className="error_btn_learn" onClick={() => navigate("/")}>
            Go To Home
          </button>
          <button className="error_btn_explore" onClick={Explore_btn_lnk}>
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
